import styled from "styled-components"

export const Container = styled.div`
  width: 100%;
  padding: 0 24px;

  @media (min-width: 767px) {
    width: 734px;
    padding: 0;
    margin: 0 auto;
  }
`;